export const themes = [
    "blue",
    "gray",
    "green",
    "neutral",
    "orange",
    "red",
    "rose",
    "slate",
    "stone",
    "violet",
    "yellow",
    "zinc",
    "fluster",
] as const;
